import { WidgetSlot, WidgetSlotConfiguration, WidgetType } from '@/api/rest/resources/types/widget';
import { useYearsRangeForHabitatIntactness } from '@/hooks/useYearsRangeForHabitatIntactness';
import { range } from '@/utils/range';

import { useControlsContext } from './useFormControls';

export const useHabitatIntactnessYearsRadioButtonGroupWidget = ({
  controlsForm,
  name,
  onValueChange,
}: {
  controlsForm: ReturnType<typeof useControlsContext>;
  name: string;
  onValueChange: () => void;
}) => {
  const yearsRange = useYearsRangeForHabitatIntactness();

  if (!yearsRange) {
    return null;
  }

  const years = range(yearsRange[0], yearsRange[1])
    .reverse()
    .map((n) => n.toString());

  return {
    name: 'heat_map_habitat_intactness_layer_picker_content',
    type: WidgetType.o_form_picker_content,
    visible: true,
    relatedData: {},
    widgets: [
      {
        name: 'heat_map_layer_radio_group',
        type: WidgetType.o_form_radio_group,
        visible: true,
        relatedData: {
          controlsForm,
          name,
          onValueChange,
        },
        widgets: years.map(
          (year): WidgetSlot => ({
            name: `${year}`,
            type: WidgetType.o_form_radio_item,
            visible: true,
            relatedData: { key: `${year}`, label: `${year}`, value: `${year}` },
          }),
        ),
      },
    ],
  } as WidgetSlotConfiguration;
};
